export const emptyUserData = {
  name: "",
  user_id: -1,
  is_faculty: false,
  saved_recommendations: [],
};
